var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.38957 8.86498C1.79069 9.24619 2.42488 9.23004 2.80609 8.82893L7.9468 3.41965L13.3484 8.55303C13.7495 8.93424 14.3837 8.91809 14.7649 8.51698C15.1461 8.11586 15.1299 7.48166 14.7288 7.10046L8.6094 1.28485C8.60662 1.28215 8.60383 1.27947 8.60102 1.27679C8.52813 1.20752 8.44754 1.15137 8.36218 1.10827C7.97773 0.914041 7.49628 0.98446 7.18429 1.31275C7.17941 1.31789 7.17459 1.32306 7.16984 1.32828L1.35351 7.44847C0.972307 7.84958 0.988452 8.48378 1.38957 8.86498Z",
    fill: "#778294"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.c3bcc61c19e49f3de8f6c9d68ae4f85b.svg";
export { ForwardRef as ReactComponent };